// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"920f840b","404":"7769caee","498":"75d02b42","787":"b68cb3d8"}[chunkId] + ".chunk.js";
};